// One place for date display. The whole app shows dates as DD/MM/YYYY.

const pad = (n) => String(n).padStart(2, "0");

function toDate(v) {
  if (!v) return null;
  if (v instanceof Date) return isNaN(v) ? null : v;
  if (typeof v === "string") {
    // plain YYYY-MM-DD -> treat as local midnight (no timezone shift)
    const m = v.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (m) return new Date(+m[1], +m[2] - 1, +m[3]);
  }
  const d = new Date(v);
  return isNaN(d) ? null : d;
}

/** DD/MM/YYYY (returns the raw value if it isn't a parseable date, "—" if empty). */
export function fmtDate(v, fallback = "—") {
  const d = toDate(v);
  if (!d) return v ? String(v) : fallback;
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
}

/** DD/MM/YYYY, HH:MM (24h). */
export function fmtDateTime(v, fallback = "—") {
  const d = toDate(v);
  if (!d) return fallback;
  return `${fmtDate(d)}, ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** DD/MM/YYYY, HH:MM am/pm. */
export function fmtDateTime12(v, fallback = "—") {
  const d = toDate(v);
  if (!d) return fallback;
  let h = d.getHours();
  const ap = h >= 12 ? "pm" : "am";
  h = h % 12 || 12;
  return `${fmtDate(d)}, ${h}:${pad(d.getMinutes())} ${ap}`;
}

/** "12 Jun 2027" — for slightly more human contexts. */
export function fmtDateLong(v, fallback = "—") {
  const d = toDate(v);
  if (!d) return fallback;
  const mon = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return `${d.getDate()} ${mon[d.getMonth()]} ${d.getFullYear()}`;
}
